import type { DynamicExperienceProps } from '@highereducation/dynamic-experience';

export interface DynamicExperienceTenantConfig {
  domain?: string;
  displayName?: string;
  siteName?: string;
  affiliate?: string;
  appExperienceUrl?: string;
  identityToken?: string;
  tagularSourceKey?: string;
  tagularApiKey?: string;
}

export function buildDynamicExperienceTenant(
  config: DynamicExperienceTenantConfig,
): DynamicExperienceProps['tenant'] {
  return {
    tagularSourceKey: config.tagularSourceKey?.trim() ?? '',
    domain: config.domain || undefined,
    displayName: config.displayName || config.siteName || undefined,
    affiliate: config.affiliate || undefined,
    appExperienceUrl: config.appExperienceUrl || undefined,
    identityToken: config.identityToken || undefined,
    tagularApiKey: config.tagularApiKey || undefined,
  };
}
